export default __webpack_public_path__ + "static/media/help-rav-inv-24.28415e89.png";